import { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, Award } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function PodiumRow({ entry, place }) {
  const emoji = place === 1 ? '🥇' : place === 2 ? '🥈' : '🥉';
  return (
    <div className="flex items-center gap-2 text-xs">
      <span className="text-base">{emoji}</span>
      <span className="font-semibold truncate flex-1">@{entry.handle}</span>
      <span className="font-bold tabular-nums">{entry.score_display}</span>
    </div>
  );
}

function WeekCard({ week }) {
  return (
    <div className="rounded-xl border border-amber-300/40 dark:border-amber-700/40 bg-gradient-to-br from-amber-50/50 to-card dark:from-amber-950/20 dark:to-card p-3" data-testid={`hof-week-${week.week_id}`}>
      <div className="flex items-center gap-2 mb-1.5">
        <Award className="w-3.5 h-3.5 text-amber-600 dark:text-amber-400" />
        <p className="text-[10px] uppercase font-bold tracking-wide text-amber-700 dark:text-amber-400">
          {week.week_id}
        </p>
      </div>
      <p className="text-xs font-bold mb-2 line-clamp-1">{week.theme_name}</p>
      <div className="space-y-1">
        {week.top3.map((e, i) => (
          <PodiumRow key={`${e.handle}-${i}`} entry={e} place={i + 1} />
        ))}
      </div>
    </div>
  );
}

export default function HallOfFame() {
  const [weeks, setWeeks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/community/leaderboard/hall-of-fame`, { params: { limit: 6 } })
      .then((r) => { if (!cancelled) setWeeks(r.data?.weeks || []); })
      .catch(() => { if (!cancelled) setWeeks([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return (
      <div className="rounded-2xl border border-border bg-card p-4 text-xs text-muted-foreground flex items-center gap-2" data-testid="hof-loading">
        <Loader2 className="w-3.5 h-3.5 animate-spin" /> Loading Hall of Fame…
      </div>
    );
  }
  if (!weeks || weeks.length === 0) return null;

  return (
    <div className="rounded-2xl border border-border bg-card p-4 mt-4" data-testid="hall-of-fame">
      <div className="flex items-center gap-2 mb-3">
        <Award className="w-5 h-5 text-amber-500" />
        <h3 className="text-base font-bold">Hall of Fame</h3>
        <span className="text-xs text-muted-foreground">past weeks</span>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {weeks.map((w) => <WeekCard key={w.week_id} week={w} />)}
      </div>
    </div>
  );
}
